import * as React from 'react';
import Svg, {G, Line, Path, SvgProps} from 'react-native-svg';

function SvgComponent(props: SvgProps) {
  return (
    <Svg
      width={22.477}
      height={22.123}
      viewBox="0 0 22.477 22.123"
      {...props}
      fill={'none'}
      stroke={'none'}>
      <G id="Chat_04" transform="translate(1 1)">
        <Path
          id="Union_21"
          data-name="Union 21"
          d="M9.9,20.118c-.041,0-.083.005-.125.005H1.956A2.273,2.273,0,0,1,0,17.631V9.984a3.164,3.164,0,0,1,.016-.319,10.239,10.239,0,0,1,20.461.574,9.941,9.941,0,0,1-10.238,9.884Q10.071,20.123,9.9,20.118Z"
          transform="translate(0 0)"
          fill={props.fill}
          stroke={props.fill}
          strokeWidth="2"
        />
        <Line
          id="Line_12"
          data-name="Line 12"
          x2="7.142"
          transform="translate(6.546 8.315)"
          fill="none"
          stroke="#fff"
          stroke-linecap="round"
          strokeWidth="2"
        />
        <Line
          id="Line_13"
          data-name="Line 13"
          x2="4.081"
          transform="translate(6.585 13.31)"
          fill="none"
          stroke="#fff"
          stroke-linecap="round"
          strokeWidth="2"
        />
      </G>
    </Svg>
  );
}

export default SvgComponent;
